import { changeImage } from '~/helpers/index';
import { magento } from "~/config/extensionsApi";
declare const goongjs: any;

/**
 * Cập nhật bản đồ với danh sách markers
 * @param {any[]} stores - Danh sách cửa hàng cần hiển thị trên bản đồ
 * @param {any} mapGoong - Đối tượng bản đồ Goong
 * @param {any} markerGoong - Danh sách marker hiện tại
 * @param {boolean} centerOnFirst - Có đặt trung tâm bản đồ vào cửa hàng đầu tiên không
 */
export const updateMapWithMarkers = (stores: any[], mapGoong: any, markerGoong: any, centerOnFirst = true) => {
    // Xóa các marker cũ
    markerGoong.value.forEach((marker: any) => marker.remove());

    setTimeout(() => {
        let markers: any[] = [];

        stores.forEach((store, index) => {
            if (index === 0 && centerOnFirst) {
                mapGoong.value.setCenter([store.longitude, store.latitude]).setZoom(store.zoom_level || mapGoong.value.getZoom());
            }

            let marker = new goongjs.Marker()
                .setLngLat([store.longitude, store.latitude])
                .addTo(mapGoong.value);

            markers.push(marker);
        });

        markerGoong.value = markers;
    }, 1000);
};

/**
 * Mở bản đồ Google Maps với vị trí được chỉ định
 * @param {number} latitude - Vĩ độ
 * @param {number} longitude - Kinh độ
 */
export const gotoGgMap = (latitude: number, longitude: number) => {
    if (typeof window !== 'undefined') {
        window.open(`https://www.google.com/maps/dir//${latitude},${longitude}/@${latitude},${longitude}`, "_blank");
    }
};

/**
 * Khởi tạo bản đồ Goong
 * @param {any} mapGoong - Tham chiếu đến đối tượng bản đồ
 * @param {string} apiKey - API Key của Goong
 */
export const initMap = (mapGoong: any, apiKey: string) => {
    goongjs.accessToken = apiKey;
    const mapData = new goongjs.Map({
        container: "map",
        style: "https://tiles.goong.io/assets/goong_map_web.json",
        center: [105.79449389547807, 21.023262952893536],
        zoom: 8,
    });
    mapGoong.value = mapData;
};

/**
 * Ngăn cuộn trang
 */
export const stopScrollBody = () => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = "hidden";
    }
};

/**
 * Bật cuộn trang
 */
export const startScrollBody = () => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = "unset";
    }
};

export const imageStore = (store) => {
    return changeImage(`${magento.media_url}/${store.image}`);
};

export function createSmoothscroll(from = 0, to = 0, speed = 15) {
    if (typeof window === 'undefined') return;
    
    let currentDelta = from > to ? from - to : to - from;
    let smoothscroll = () => {
        if (Math.abs(currentDelta) < speed) return;
        currentDelta = currentDelta - currentDelta / speed;
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, from > to ? to + currentDelta : to - currentDelta);
    };
    return smoothscroll();
}

export const timeToMinutes = (time) => {
    if (typeof time !== "undefined") {
        let [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
    }

};

export const getStoreStatusText = (store) => {
    switch (isOutsideWorking(store)) {
        case 0:
            return "Đang mở";
        case 1:
            return "Chưa mở cửa";
        case 2:
            return "Đóng cửa";
        default:
            return "Không xác định";
    }
};

export const getStoreStatusStyle = (store) => {
    switch (isOutsideWorking(store)) {
        case 1:
        case 2:
            return {
                backgroundColor: "rgba(218, 41, 28, 0.2)",
                color: "#DA291C",
            };
        default:
            return {};
    }
};

export const isOutsideWorking = (store) => {
    var dayData = getCurrentDay();
    var dayTimeOpen = [
        "sunday_open",
        "monday_open",
        "tuesday_open",
        "wednesday_open",
        "thursday_open",
        "friday_open",
        "saturday_open",
    ];
    var dayTimeClose = [
        "sunday_close",
        "monday_close",
        "tuesday_close",
        "wednesday_close",
        "thursday_close",
        "friday_close",
        "saturday_close",
    ];

    //0: dang mo, 1: chua mo, 2 dong cua
    let isClosed = 0;
    if (store) {
        if (
            timeToMinutes(dayData.curTime) <=
            timeToMinutes(store[dayTimeOpen[dayData.day]])
        ) {
            isClosed = 1;
        }
        if (
            timeToMinutes(store[dayTimeClose[dayData.day]]) <=
            timeToMinutes(dayData.curTime)
        ) {
            isClosed = 2;
        }
    }

    return isClosed;
};

export const getCurrentDay = () => {
    var today = new Date();
    var utcDay = today.getUTCDay(); // Lấy ngày theo UTC
    var day = Math.floor((utcDay + 7 / 24) % 7); // Dịch sang GMT+7
    var curTime =
        ("0" + today.getHours()).slice(-2) +
        ":" +
        ("0" + today.getMinutes()).slice(-2);
    return { day: day, curTime: curTime };
};